import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

export interface RelatorioPrestadores210Filtros {
  filRps?: string;
  filAcreditado?: number;
  filParticipacaoAb?: number;
}

@Injectable()
export class RelatorioPrestadores210Service {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  fetchData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtros: RelatorioPrestadores210Filtros = {},
  ) {
    return this.simuladorGoApi
      .fetchRelatorioPrestadores210({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        fil_rps: filtros.filRps,
        fil_acreditado: filtros.filAcreditado,
        fil_participacao_ab: filtros.filParticipacaoAb,
      })
      .pipe(map(data => data.items ?? []));
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchRelatorioPrestadores210UltimoProcessamento({ regans });
  }
}
